import { createTheme } from "@mui/material";
import { ThemeProvider } from "styled-components";
import { useState } from "react";
import ServiceTypeToggle from "../shared/ServiceTypeToggle";
import "./CommunicationTemplate.css";
import CommunicationTemplate from "./CommunicationTemplate";

const defaultTheme = createTheme();

const ManageCommunicationTemplete = () => {
  const [activeTab, setActiveTab] = useState<"air" | "ocean">("air");

  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="ctpl-page-header">
        <div className="ctpl-title-col">
          <h1>Communication Template</h1>
          <p>Configure WhatsApp &amp; email milestone messages sent for each shipment mode.</p>
        </div>
        <ServiceTypeToggle onTypeChange={setActiveTab} activeTab={activeTab} width="28%" />
      </div>
      <CommunicationTemplate mode={activeTab} />

    </ThemeProvider>
  );
};

export default ManageCommunicationTemplete;